import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2aa5a0be&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2aa5a0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5a0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa5a0be')) {
      api.createRecord('2aa5a0be', component.options)
    } else {
      api.reload('2aa5a0be', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2aa5a0be&scoped=true&", function () {
      api.rerender('2aa5a0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0abTc4RpKUY/JS/comp/Voucher.vue"
export default component.exports